<template>
  <FormPto
    v-model="modelFormData"
    :is-edit="isEdit"
    :is-sending="isSending"
    :clear-on-destroy="!isEdit"
    @request="onSubmit"
    @cancel="onCancel"
  >
    <PTOProjectTitle v-if="isEdit" is-edit />

    <VSelect
      label="Тип доплаты"
      itemText="surcharge_type"
      name="surcharge_type"
      ref="selectType"
      :items="fotSurchargesList"
      :handler-search="GETFotSurchargesListByBuildId"
      @change="changeType"
      search
      required
    >
      <Validation for="required">Поле обязательно</Validation>
    </VSelect>

    <VInput
      label="Объем за ед."
      name="volume"
      pattern='^\d*(?:[.]\d{0,3})?$'
      required
    >
      <Validation for="required">Поле обязательно</Validation>
      <Validation for="pattern">Формат ввода: "1000.001"</Validation>
    </VInput>

    <VInput
      :value="priceEdit"
      label="Цена"
      name="price"
      disabled
    />

  </FormPto>
</template>

<script>
import FormPto from '@/components/pto/form/FormPto'
import PTOProjectTitle from '@/components/pto/title/PTOProjectTitle'
import Validation from '@/components/page/Form/Validation.vue'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'
import VSelect from '@/components/page/Form/VSelect.vue'

import Vue from 'vue'
import { MIXIN_FORM_PTO } from '@/mixins/module/pto/mixinFormPto'
import { mapActions, mapState } from 'vuex'
import { prepareProjectOwnProductionFormData } from '@/utils/page/pto/project/estimate'

export default {
  name: 'FormPtoProjectFotProduction',
  components: {
    FormPto,
    PTOProjectTitle,
    // eslint-disable-next-line vue/no-unused-components
    Validation,
    VInput,
    VSelect
  },
  mixins: [MIXIN_FORM_PTO],
  props: {
    date: {
      type: String,
      default: ''
    }
  },
  data: () => ({}),
  computed: {
    ...mapState('handbook/pto', {
      fotSurchargesList: 'fotSurchargesList'
    }),
    priceEdit () {
      if (this.isEdit) return this.modelFormData.surcharge_type.price
      else return ''
    }
  },
  methods: {
    ...mapActions('handbook/pto', {
      GETFotSurchargesList: 'GETFotSurchargesList'
    }),
    GETFotSurchargesListByBuildId ({ search = null } = {}) {
      const buildingId = this.$store.state.pto.project.currentItem.object.building.id
      return this.GETFotSurchargesList({
        buildingId: buildingId,
        date: this.date,
        search
      })
    },
    onSubmit (data) {
      data.work_sign_id = this.$route.params.id
      this.$emit('request', prepareProjectOwnProductionFormData(data))
    },
    changeType (value) {
      Vue.set(this.modelFormData, 'price', value?.price)
    }
  },
  mounted () {
    this.GETFotSurchargesListByBuildId()
  }
}
</script>
